// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1648ccb8","977":"3fc6a1a5"}[chunkId] + ".chunk.js";
};